// shared/constants/vehicleEnums.js
// ✅ Vehicle model'den AYNEN kopyalanan enum değerleri

// ============================
// 🚗 VEHICLE ENUMS - Model'deki değerlerin tam kopyası
// ============================
const VEHICLE_ENUMS = {
    bodyType: {
        SEDAN: 'sedan',
        HATCHBACK: 'hatchback',
        SUV: 'suv',
        COUPE: 'coupe',
        CABRIOLET: 'cabriolet',
        STATION_WAGON: 'station wagon',
        PICKUP: 'pickup',
        MINIVAN: 'minivan'
    },

    fuelType: {
        BENZIN: 'benzin',
        DIZEL: 'dizel',
        LPG: 'lpg',
        ELEKTRIK: 'elektrik',
        HIBRIT: 'hibrit',
        BENZIN_LPG: 'benzin+lpg'
    },

    transmission: {
        MANUEL: 'manuel',
        OTOMATIK: 'otomatik',
        YARI_OTOMATIK: 'yarı otomatik'
    },

    status: {
        ACTIVE: 'active',
        SOLD: 'sold',
        RESERVED: 'reserved',
        ARCHIVED: 'archived'
    },

    warrantyStatus: {
        VAR: 'Var',
        YOK: 'Yok',
        EMPTY: ''
    },

    expertizStatus: {
        ORIGINAL: 'original',
        PAINTED: 'painted',
        LOCAL_PAINT: 'local_paint',
        REPLACED: 'replaced',
        DAMAGED: 'damaged'
    },

    expenseType: {
        BAKIM_HASAR: 'bakim_hasar',
        YAKIT: 'yakit',
        TEMIZLIK_DETAY: 'temizlik_detay',
        MUAYENE: 'muayene',
        PARK_OTOPARK: 'park_otopark',
        YOL_MASRAFI: 'yol_masrafi',
        YEMEK: 'yemek',
        DIGER: 'diger'
    },

    documentType: {
        ALIS_SOZLESMESI: 'alis_sozlesmesi',
        SATIS_SOZLESMESI: 'satis_sozlesmesi',
        RUHSAT: 'ruhsat',
        TRAFIK_SIGORTASI: 'trafik_sigortasi',
        ALIS_FATURASI: 'alis_faturasi'
    }
};

// ============================
// 📋 DISPLAY LABELS
// ============================
const VEHICLE_ENUM_LABELS = {
    bodyType: {
        'sedan': 'Sedan',
        'hatchback': 'Hatchback',
        'suv': 'SUV',
        'coupe': 'Coupe',
        'cabriolet': 'Cabriolet',
        'station wagon': 'Station Wagon',
        'pickup': 'Pickup',
        'minivan': 'Minivan'
    },

    fuelType: {
        'benzin': 'Benzin',
        'dizel': 'Dizel',
        'lpg': 'LPG',
        'elektrik': 'Elektrik',
        'hibrit': 'Hibrit',
        'benzin+lpg': 'Benzin+LPG'
    },

    transmission: {
        'manuel': 'Manuel',
        'otomatik': 'Otomatik',
        'yarı otomatik': 'Yarı Otomatik'
    },

    status: {
        'active': 'Aktif',
        'sold': 'Satıldı',
        'reserved': 'Rezerve',
        'archived': 'Arşivlendi'
    },

    warrantyStatus: {
        'Var': 'Var',
        'Yok': 'Yok',
        '': 'Belirtilmemiş'
    },

    expertizStatus: {
        'original': 'Orjinal',
        'painted': 'Boyalı',
        'local_paint': 'Lokal Boya',
        'replaced': 'Değişen',
        'damaged': 'Hasarlı'
    },

    expenseType: {
        'bakim_hasar': 'Bakım & Hasar',
        'yakit': 'Yakıt',
        'temizlik_detay': 'Temizlik & Detay',
        'muayene': 'Muayene',
        'park_otopark': 'Park & Otopark',
        'yol_masrafi': 'Yol Masrafı',
        'yemek': 'Yemek',
        'diger': 'Diğer'
    },

    documentType: {
        'alis_sozlesmesi': 'Alış Sözleşmesi',
        'satis_sozlesmesi': 'Satış Sözleşmesi',
        'ruhsat': 'Ruhsat',
        'trafik_sigortasi': 'Trafik Sigortası',
        'alis_faturasi': 'Alış Faturası'
    }
};

// ============================
// 🔄 LEGACY MAPPING - Eski değerleri normalize et
// ============================
const LEGACY_ENUM_MAPPINGS = {
    transmission: {
        // Büyük/küçük harf variasyonları
        'Otomatik': 'otomatik',
        'OTOMATIK': 'otomatik',
        'automatic': 'otomatik',
        'Manuel': 'manuel',
        'MANUEL': 'manuel',
        'manual': 'manuel',
        'Yarı Otomatik': 'yarı otomatik',
        'YARI OTOMATIK': 'yarı otomatik',
        'yari otomatik': 'yarı otomatik',
        'semi automatic': 'yarı otomatik'
    },

    fuelType: {
        'Benzin': 'benzin',
        'BENZIN': 'benzin',
        'gasoline': 'benzin',
        'Dizel': 'dizel',
        'DIZEL': 'dizel',
        'diesel': 'dizel',
        'Elektrik': 'elektrik',
        'ELEKTRIK': 'elektrik',
        'electric': 'elektrik',
        'Hibrit': 'hibrit',
        'HIBRIT': 'hibrit',
        'hybrid': 'hibrit',
        'Benzin+LPG': 'benzin+lpg',
        'benzin+LPG': 'benzin+lpg',
        'BENZIN+LPG': 'benzin+lpg'
    },

    bodyType: {
        'Sedan': 'sedan',
        'SEDAN': 'sedan',
        'Hatchback': 'hatchback',
        'HATCHBACK': 'hatchback',
        'SUV': 'suv',
        'Suv': 'suv',
        'Coupe': 'coupe',
        'COUPE': 'coupe',
        'Cabriolet': 'cabriolet',
        'CABRIOLET': 'cabriolet',
        'convertible': 'cabriolet',
        'Station Wagon': 'station wagon',
        'STATION WAGON': 'station wagon',
        'station_wagon': 'station wagon',
        'Pickup': 'pickup',
        'PICKUP': 'pickup',
        'Minivan': 'minivan',
        'MINIVAN': 'minivan'
    }
};

// ============================
// 🛠️ HELPER FUNCTIONS
// ============================
const normalizeEnumValue = (value, enumType) => {
    if (!value) return value;

    const cleanValue = String(value).trim();
    const lowerValue = cleanValue.toLowerCase();

    // 1. Zaten doğru değer mi?
    const validValues = Object.values(VEHICLE_ENUMS[enumType] || {});
    if (validValues.includes(cleanValue)) {
        return cleanValue;
    }
    if (validValues.includes(lowerValue)) {
        return lowerValue;
    }

    // 2. Legacy mapping kontrolü
    const legacyMappings = LEGACY_ENUM_MAPPINGS[enumType] || {};

    // Exact match
    if (legacyMappings[cleanValue]) {
        return legacyMappings[cleanValue];
    }

    // Case insensitive match
    if (legacyMappings[lowerValue]) {
        return legacyMappings[lowerValue];
    }

    // 3. Bulunamazsa warning + original değer
    console.warn(`⚠️ ${enumType} için normalize edilemeyen değer: "${value}"`);
    return cleanValue;
};

const getEnumOptions = (enumType) => {
    const enumValues = VEHICLE_ENUMS[enumType];
    const enumLabels = VEHICLE_ENUM_LABELS[enumType];

    if (!enumValues || !enumLabels) {
        console.error(`❌ Bilinmeyen enum tipi: ${enumType}`);
        return [];
    }

    return Object.values(enumValues).map(value => ({
        value,
        label: enumLabels[value] || value
    }));
};

const getValidEnumValues = (enumType) => {
    return Object.values(VEHICLE_ENUMS[enumType] || {});
};

const getEnumLabel = (enumType, value) => {
    if (!value) return '';

    const normalizedValue = normalizeEnumValue(value, enumType);
    const labels = VEHICLE_ENUM_LABELS[enumType];

    return labels?.[normalizedValue] || normalizedValue;
};

// ============================
// 📤 EXPORTS
// ============================
if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
        VEHICLE_ENUMS,
        VEHICLE_ENUM_LABELS,
        LEGACY_ENUM_MAPPINGS,
        normalizeEnumValue,
        getEnumOptions,
        getValidEnumValues,
        getEnumLabel
    };
}

export {
    VEHICLE_ENUMS,
    VEHICLE_ENUM_LABELS,
    LEGACY_ENUM_MAPPINGS,
    normalizeEnumValue,
    getEnumOptions,
    getValidEnumValues,
    getEnumLabel
};